export const IMPORT_EXCEL = {
  title: 'Importer des réseaux numériques',
  dragDrop: {
    title: 'Ajouter votre fichier',
    formatAndMaxSize: 'Au format xlsx, 10 Mo maximum',
  },
  actions: {
    cancel: 'Annuler',
    add: 'Ajouter',
  },
  recap: {
    fileName: 'Nom du fichier',
  },
  messages: {
    prevent: 'Toutes vos ventes sont sur le point d\'être écrasées par les ventes de votre fichier',
    click: 'Cliquez sur ajouter pour valider',
    sucessCreationLignes: 'Les lignes de commandes ont été créées avec succès.',
    errorCreationLignes: 'Impossible de créer les lignes de commandes.',
  },
};

export const EXPORT_EXCEL_RESEAU_NUM = {
  exportExcel: 'Exporter réseaux numériques',
  importExcel: 'Importer réseaux numériques',
  messages: {
    excelExportError: 'Impossible d\'exporter les produits réseaux numériques',
    sucessCreationExcel: 'Le fichier excel a été généré avec succès.',
  },
  excelInfo: {
    title: 'Info réseaux numériques',
    fileName: 'Réseaux numériques.xlsx',
  },
};

export const EXPORT_EXCEL_FACE = {
  excelInfo: {
    title: 'Info face du réseau',
    fileName: 'Face du réseau.xlsx',
  },
  messages: {
    excelExportError: 'Impossible d\'exporter les faces du réseau',
    sucessCreationExcel: 'Le fichier excel a été généré avec succès.',
    excelExportErrorNoFace: 'Impossible d\'exporter les faces du réseau : aucune face ajoutée à la date du jour',
  },
  yes: 'Oui',
  no: 'Non',
  columnExcel: {
    code: 'Code Face',
    libelle: 'Libellé',
    format: 'Format',
    materiel: 'Matériel',
    adresse: 'Adresse',
    codePostal: 'Code postal',
    ville: 'Ville',
    dateDebut: 'Date début',
    dateFin: 'Date fin',
    latitude: 'Latitude',
    longitude: 'Longitude',
    localisation: 'Localisation',
    angle: 'Angle de vue',
    eclaire: 'Eclairée',
    sousReseau: 'Sous réseau',
  },
};

export const EXPORT_EXCEL_FACE_SELECT_IN_VENTE_TEMPO = {
  excelInfo: {
    title: 'Faces sélectionnées réseau',
    fileName: 'Faces sélectionnées.xlsx',
    titleInSheet: 'Réseau {code} ({libelle}) à la semaine {anneeSemaine} - du {dateDebut} au {dateFin}',
    titleDemandeInSheet: 'Demande {libelle} au {dateDebut}',
  },
  messages: {
    excelExportError: 'Impossible d\'exporter les faces du réseau',
    sucessCreationExcel: 'Le fichier excel a été généré avec succès.',
    excelExportErrorNoFace: 'Impossible d\'exporter les faces du réseau : aucune face ajoutée à la date du jour',
  },
  columnExcel: {
    dispo: 'Dispo',
    panneau: 'Panneau',
    face: 'Face',
    format: 'Format',
    longueur: 'Longueur (cm)',
    largeur: 'Hauteur (cm)',
    materiel: 'Matériel',
    adresse: 'Adresse',
    ville: 'Ville',
    restriction: 'Restriction',
    logistique: 'Logistique',
    reference: 'Face',
    affecteLogistiquement: 'Affecté logistiquement',
    codePostal: 'Code postal',
    latitude: 'Latitude',
    longitude: 'Longitude',
    reseau: 'Réseau',
    dateDepart: 'Date de départ',
  },
};
export const EXPORT_EXCEL_FACE_SELECT_IN_VENTE_TEMPO_FOR_RESEAU_PERSO = {
  excelInfo: {
    title: 'Faces sélectionnées réseau',
    fileName: 'Faces sélectionnées.xlsx',
  },
  messages: {
    excelExportError: 'Impossible d\'exporter les faces des réseaux',
    sucessCreationExcel: 'Le fichier excel a été généré avec succès.',
    excelExportErrorNoFace: 'Impossible d\'exporter les faces des réseaux',
  },
  columnExcel: {
    dispo: 'Dispo',
    panneau: 'Panneau',
    codeReseau: 'Code Réseau',
    reseauLibelle: 'Libellé réseau',
    dateDepart: 'Date de départ',
    face: 'Face',
    format: 'Format',
    materiel: 'Matériel',
    adresse: 'Adresse',
    ville: 'Ville',
    restriction: 'Restriction',
    logistique: 'Logistique',
    reference: 'Face',
    affecteLogistiquement: 'Affecté logistiquement',
    codePostal: 'Code postal',
    latitude: 'Latitude',
    longitude: 'Longitude',
  },
};
